import { ReactNode } from 'react'

import { DetailsList } from '@/components/ui/details-list'
import { Flex } from '@/components/ui/flex'
import { Typography } from '@/components/ui/typography'

interface DetailsSectionProps {
  children: ReactNode
  title: string
}

export const DetailsSection = ({ children, title }: DetailsSectionProps) => (
  <Flex direction="column" gap={8}>
    <Typography color="black800" size="text-small" weight="semibold">
      {title}
    </Typography>
    <DetailsList>{children}</DetailsList>
  </Flex>
)
